import React from "react";
import {
  useId,
  Spinner,
  Toaster,
  useToastController,
  ToastTitle,
  Toast,
  ToastTrigger,
  Link,
} from "@fluentui/react-components";

const useToast = () => {
  const toasterId = useId("toaster");
  const { dispatchToast, dismissAllToasts } = useToastController(toasterId);

  const notify = (intent = "success", message) => {
    const errorStyle = {
      backgroundColor: "#ffe5e5", // light red
      border: "1px solid red",
      color: "black",
      fontSize: "12px",
      alignItem: "center"
    };
    
   if (intent === "error") {
      // Dismiss all existing toasts before showing a new error
      dismissAllToasts();
    }

    switch (intent) {
      case "progress":
        dispatchToast(
          <Toast>
            <ToastTitle media={<Spinner size="tiny" />}>In Progress...</ToastTitle>
          </Toast>
        );
        break;
      case "error":
        dispatchToast(
          <Toast style={errorStyle}>
            <ToastTitle
             action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
            >{message}</ToastTitle>
          </Toast>,
          {
            intent,
            timeout: -1, // disables auto-dismiss
          }
        );
        break;
      case "info":
      case "success":
      case "warning":
        dispatchToast(
          <Toast>
            <ToastTitle>{message}</ToastTitle>
          </Toast>,
          { intent }
        );
        break;
    }
  };

  return { notify, dismissAllToasts, Toaster: <Toaster toasterId={toasterId} /> };
};

export default useToast;